import React, { useState, useEffect } from 'react';
import AuthContext from '../../contexts/AuthContext';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useTopic } from '../../contexts/TopicContext';
import { AiOutlineClose } from 'react-icons/ai';
import ButtonTraining from '../../components/buttons/ButtonTraining';
import { TbHierarchy3 } from "react-icons/tb";
import { Link } from 'react-router-dom';
import { Exercise } from '../../containers/exercisePage/Exercise';
import Modal from '../../components/modal/Modal';
import AuthService from '../../services/AuthService';
//import './TopBar.css';

const TopBar = ({ topicId, onCloseModal, onExerciseClick, onTestClick }) => {

    const { user } = React.useContext(AuthContext);
    const topicData = useTopic();

    const [modalOpen, setModalOpen] = React.useState(false);
    const [modalContent, setModalContent] = React.useState('exercise');
    const [trainingDisabled, setTrainingDisabled] = useState(true); // Training button state
    const [trialDisabled, setTrialDisabled] = useState(true); // Trial button state
    const [trialCompleted, setTrialCompleted] = useState(true); 
    const [trainingCompleted, setTrainingCompleted] = useState(true); 
    const [trialMessage, setTrialMessage] = useState("");
    const [trainingMessage, setTrainingMessage] = useState(""); 
    const [questionExist, setQuestionExist] = useState(true); 
    const [skipped, setSkipped] = useState(true);
    const [skipMessage, setSkipMessage] = useState("");
    const [skipDisabled, setSkipDisabled] = useState(true);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    // Fetch eligibility from the backend
    const fetchEligibility = async () => {
        setLoading(true);
        try {
            if (!user) return;

            const response = await fetch('/api/topic/getTrialEligibility', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    topicID: Number(topicId),
                    userID: user.userProfileId,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch eligibility');
            }

            const data = await response.json();

            if (!data.questionExist) {
                setQuestionExist(false)
            }

            // Update button states based on response
            setTrainingDisabled(!data.trainingEligible);
            setTrialDisabled(!data.trialEligible);
            setTrialCompleted(data.trialCompleted);
            setTrainingCompleted(data.trainingCompleted);
            setTrialMessage(data.trialMessage);
            setTrainingMessage(data.trainingMessage);
            setSkipDisabled(!data.skipEligible);
            setSkipMessage(data.skipMessage);
            setSkipped(data.skipped);

            // Set progress text and color
            const index = data.trainingEligible ? 2 : 0; // Example mapping
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Fetch eligibility on mount or when topicId changes
    useEffect(() => {
        fetchEligibility();
    }, [topicId, user?.topicStatus]);

    const skipTopic = async () => {
        if (!user) return;

        const response = await fetch('/api/topic/setProgress', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                topicID: topicId,
                userID: user.userProfileId,
                status: 'learned',
            }),
        });

        if (response.ok) {
            const res = await response.json();
            if (user.topicStatus) {
                user.topicStatus = res.data.topicStatus;
                AuthService.syncLocalUserSession(user);
            }
            setSkipped(true);
        }
    };

    const onLocalexerciseClick = async () => {
        setModalContent('exercise');
        setModalOpen(true);
        console.log("happe");
    };

    const onLocaltrialClick = async () => {
        setModalContent('test');
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <div id="top-bar">
            <div className="row">
                <div className="col-4">
                    {onCloseModal && ( // Only show the back button if onCloseModal is defined
                        <button className="close-button btn-remove-style" onClick={onCloseModal}>
                            <AiOutlineClose size={24} />
                        </button>
                    )}
                </div>
                <div className="col-4 text-center">
                    <div id="title-container">
                        {topicData ? (
                            <>
                                <span className="font-1">{topicData.name}</span>
                                <Link
                                    to={`/home?node=${topicId}`}
                                    onClick={onCloseModal} // Use topicId as a unique key to force re-render
                                >
                                    <TbHierarchy3 size={20} className='icon-lift-5 icon-right-10' />
                                </Link>
                            </>
                        ) : (
                            <Skeleton count={1} width={200}/>
                        )}
                    </div>
                </div>
                <div className="col-12 col-lg-4 text-lg-right text-center mt-3 mt-lg-0">
                    {user && user.topicStatus && !loading && ( 
                        questionExist ? (
                        <div>
                            <ButtonTraining value={'Training'} className="tkmr_orange_bg" onClick={onExerciseClick ? onExerciseClick : onLocalexerciseClick} disabled={trainingDisabled} completed={trainingCompleted} tooltipMessage={trainingMessage} />
                            <ButtonTraining value={'Trial'} className="tkmr_green_bg" onClick={onTestClick ? onTestClick : onLocaltrialClick} disabled={trialDisabled} completed={trialCompleted} tooltipMessage={trialMessage} />
                        </div>
                        ) : (
                        <div>
                            <ButtonTraining value={'Skip'} className="tkmr_green_bg" onClick={skipTopic} disabled={skipDisabled} completed={skipped} tooltipMessage={skipMessage} />
                        </div>
                        )
                    )}
                </div>
            </div>

            {!(onExerciseClick && onTestClick) && ( 
                <Modal
                    isOpen={modalOpen}
                    onClose={closeModal}
                    content={<Exercise topicId={topicId} type_={modalContent} onBackToTopic={closeModal} />}
                    containerPadding={modalContent === 'exercise' || modalContent === 'test' ? false : true}
                    clickOutsideClose={modalContent === 'exercise' || modalContent === 'test' ? false : true}
                />
            )}



        </div>
    );
};

export default TopBar;
